import { useEffect, useState } from 'react';
import {
  DEFAULT_CONSENT,
  getConsent,
  hasMadeChoice,
  acceptAll,
  rejectNonEssential,
  setConsent,
  onReopenBanner
} from '../utils/consent.js';

export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  const [customize, setCustomize] = useState(false);
  const [choices, setChoices] = useState(DEFAULT_CONSENT);

  useEffect(() => {
    if (!hasMadeChoice()) setOpen(true);
    return onReopenBanner(() => {
      const saved = getConsent() || DEFAULT_CONSENT;
      setChoices(saved);
      setCustomize(true);
      setOpen(true);
    });
  }, []);

  if (!open) return null;

  const close = () => {
    setOpen(false);
    setCustomize(false);
  };

  const handleAcceptAll = () => {
    acceptAll();
    close();
  };

  const handleRejectAll = () => {
    rejectNonEssential();
    close();
  };

  const handleSave = () => {
    setConsent(choices);
    close();
  };

  const toggle = (key) => (e) => setChoices((c) => ({ ...c, [key]: e.target.checked }));

  return (
    // data-client-only: opens after mount (consent lives in localStorage), so
    // the prerender drops it to match the first client render.
    <div className="cookie-banner" role="dialog" aria-modal="false" aria-labelledby="cookie-banner-title" data-client-only>
      <div className="cookie-banner__inner">
        <div className="cookie-banner__copy">
          <h2 id="cookie-banner-title" className="cookie-banner__title">We use cookies</h2>
          <p className="cookie-banner__text">
            We use cookies to make Account Editor work, measure how the site is used, and improve it.
            Read our <a href="/cookie-settings">cookie settings</a> for details.
          </p>
        </div>

        {customize && (
          <fieldset className="cookie-banner__options">
            <legend className="visually-hidden">Cookie categories</legend>
            <label className="cookie-banner__option">
              <input type="checkbox" checked disabled />
              <span><strong>Strictly necessary</strong> — required for the site to work.</span>
            </label>
            <label className="cookie-banner__option">
              <input type="checkbox" checked={choices.functional} onChange={toggle('functional')} />
              <span><strong>Functional</strong> — remembers preferences and recently viewed content.</span>
            </label>
            <label className="cookie-banner__option">
              <input type="checkbox" checked={choices.analytics} onChange={toggle('analytics')} />
              <span><strong>Analytics</strong> — aggregate usage to help us improve.</span>
            </label>
            <label className="cookie-banner__option">
              <input type="checkbox" checked={choices.marketing} onChange={toggle('marketing')} />
              <span><strong>Marketing</strong> — attribution and retargeting.</span>
            </label>
          </fieldset>
        )}

        <div className="cookie-banner__actions">
          {!customize && (
            <button type="button" className="cookie-banner__btn cookie-banner__btn--ghost" onClick={() => setCustomize(true)}>
              Customize
            </button>
          )}
          <button type="button" className="cookie-banner__btn cookie-banner__btn--ghost" onClick={handleRejectAll}>
            Reject non-essential
          </button>
          {customize ? (
            <button type="button" className="cookie-banner__btn cookie-banner__btn--primary" onClick={handleSave}>
              Save preferences
            </button>
          ) : (
            <button type="button" className="cookie-banner__btn cookie-banner__btn--primary" onClick={handleAcceptAll}>
              Accept all
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
